import { mapGetters } from 'vuex';

export default {
    computed: {
		...mapGetters([
            'fieldShortcodes',
			'poFieldShortcodes',
	    	'keyedCustomers',
			'keyedFieldOptions',
			'keyedProducts'
	  	])
    },
    methods: {
        replaceShortcodes({ value, rowindex, keyedFieldValues, decorate = true, assignment_type }) {
            let newvalue = value;
            if(keyedFieldValues && !!value){
                let selectors = value.match(/\[(.*?)(?=\s|\])(.*?)](.*?\[\/\1])?/g);
                if(selectors){
                    for (let i = 0, selector; selector = selectors[i]; i++){
                        let internalname = selector.replace('[', '').replace(']', ''),
                            replacement = '',
                            property = null,
							shortcodes = (assignment_type === 'purchase-order') ? this.poFieldShortcodes : this.fieldShortcodes;

                        if(internalname && internalname.includes('.')){
                            let nameparts = internalname.split('.');
                            internalname = nameparts[0];
                            property = nameparts[1]
                        }

                        let shortcode = shortcodes[internalname],
                            fieldid = shortcode.id,
                            val = (keyedFieldValues[fieldid] ? keyedFieldValues[fieldid] : '');


                        if(fieldid){
                            if(val.orderitem){
                                val = keyedFieldValues[fieldid][rowindex];
                            }
                            if(val && val.value != null){
                                let field = this.keyedFields[fieldid];
                                replacement = '"' + this.getValue(field, val, property, decorate)+'"';
                            }else{
                                replacement = '""';
                            }
                        }

                        newvalue = newvalue.replace(selector, replacement);
                    }
                }else{
                    newvalue = '"' + newvalue + '"';
                }
            }
            if(newvalue){
                let val = null;
                try {
                    newvalue = eval(newvalue);
                    newvalue = newvalue+'';
                } catch (e) {
                    console.log(e);
                }
            }
            return newvalue;
        }
    }
}
